import { FunctionComponent } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { isRTL } from 'core/services/language';
import Icon from 'utils/icon';

interface BackButtonProps {
	styles?: React.CSSProperties;
	customBack?: string;
}

const BackButton: FunctionComponent<BackButtonProps> = ({ styles, customBack }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleNavigateBack = () => {
		customBack ? navigate(customBack) : navigate(-1);
	};

	return (
		<Button type="link" onClick={handleNavigateBack} style={{ padding: 0, marginBottom: 15, ...styles }}>
			<Icon
				name="backArrow"
				width={14}
				height={14}
				color="var(--primary)"
				style={{ transform: isRTL() ? 'rotate(180deg)' : '', marginTop: isRTL() ? '3px' : '2px' }}
			/>
			{t('COMMON.BACK')}
		</Button>
	);
};

export default BackButton;
